import { Button, Form, Input, message } from 'antd'
import RouteList from 'pages/Routes'
import { useNavigate } from 'react-router-dom'
import handle from 'services/Axios'
import SWR_KEY from 'services/swr/constant'
import useSWRMutation from 'swr/mutation'
import { useTranslation } from 'translations'

const ForgotPassword = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const [form] = Form.useForm()

  /**
   * Functions
   * ============================================================================
   */

  const { trigger: handleConfirm, isMutating } = useSWRMutation(SWR_KEY.FORGOT_PASSWORD, async (url: string, { arg }) => {
    try {
      await handle.post(url, arg)

      message.success(t('checkYourEmail'))
      form.resetFields()
      setTimeout(() => navigate(RouteList.signIn), 1500)
    } catch (error: any) {
      message.error(error.message)
    }
    return
  })

  const handleSubmit = () => {
    form.validateFields().then((values) => {
      handleConfirm(values)
    })
  }

  return (
    <div className='flex flex-col gap-6 py-10'>
      <h1 className='flex-1 text-2xl font-bold'>{t('forgotPassword')}</h1>
      <Form form={form} layout='vertical'>
        <Form.Item
          label={t('Enter your email')}
          name='email'
          rules={[
            { required: true, message: t('Email is require') },
            {
              type: 'email',
              message: t('Invalid Email'),
            },
          ]}
        >
          <Input size='large' placeholder={t('Email')} />
        </Form.Item>
      </Form>

      <Button type='primary' className='min-h-[42px] flex-1' loading={isMutating} onClick={handleSubmit}>
        {t('Confirm')}
      </Button>

      <div
        className='cursor-pointer py-2 px-3 rounded-[80px] flex items-center justify-center gap-2 bg-[#f5f6f8] w-fit mx-auto'
        onClick={() => navigate(RouteList.signIn)}
      >
        <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='#FF880A' viewBox='0 0 25 24' color='#FF880A'>
          <path
            fillRule='evenodd'
            d='m5.96 4.12 5.5-2.06c.57-.21 1.51-.21 2.07.01l5.5 2.06c1.05.39 1.91 1.64 1.91 2.76v8.1c0 .81-.53 1.87-1.18 2.36l-5.5 4.11c-.97.73-2.56.73-3.53 0l-5.5-4.11c-.65-.48-1.18-1.55-1.18-2.36v-8.1c0-1.13.86-2.37 1.91-2.77Zm4.67 9.89c.15.15.34.22.53.22s.38-.07.53-.22l4.3-4.3c.29-.29.29-.77 0-1.06a.754.754 0 0 0-1.06 0l-3.77 3.77-1.08-1.08a.755.755 0 0 0-1.06 0c-.29.29-.29.77 0 1.06l1.61 1.61Z'
            clipRule='evenodd'
          ></path>
        </svg>
        <p>
          {t('Already have an account?')} <span className='contents text-[#1677ff]'>{t('Log in')}</span>{' '}
          {t('to continue receiving your rewards.')}
        </p>
      </div>
    </div>
  )
}

export default ForgotPassword
